import type { LocaleCatalog } from "../types";

const n = (event: { payload?: Record<string, string | number | boolean> }, key: string, fallback: string | number) =>
  event.payload?.[key] ?? fallback;

export const pl = {
  ui: {
    brandTagline: "KARTOGRAFIA MIĘDZYSYSTEMOWA",
    introSub: "KX / PRZEKAŹNIK MIDGARD",
    introTitle: "PRZESTRZEŃ MIĘDZY SYSTEMAMI",
    systemsNominal: "KONSTELACJA NOMINALNA",
    command: "KOMENDY",
    commandPaletteLabel: "Paleta komend K·NEXUS",
    commandPlaceholder: "Szukaj systemów, światów i tożsamości orbitalnych…",
    commandEmpty: "Brak sygnału na tych współrzędnych.",
    navHeading: "NAWIGACJA",
    entitiesHeading: "ENCJE I ARTEFAKTY",
    orbitalHeading: "TOŻSAMOŚCI ORBITALNE",
    returnToCosmos: "Powrót do mapy",
    returnToCosmosDetail: "Wróć do pełnej kartografii międzysystemowej",
    navigate: "NAWIGUJ",
    focus: "FOKUS",
    close: "ZAMKNIJ",
    allSystems: "WSZYSTKIE SYSTEMY",
    map: "MAPA",
    frame: "KADR",
    local: "LOKALNY",
    cosmos: "KOSMOS",
    find: "SZUKAJ",
    sound: "DŹWIĘK",
    access: "DOSTĘP",
    focusLabel: "FOKUS",
    edge: "EDGE",
    data: "DANE",
    hybridMock: "HYBRYDA / MOCK",
    live: "LIVE",
    fallback: "FALLBACK",
    activity: "AKTYWNOŚĆ",
    liveEventFabric: "ŻYWA TKANKA SYGNAŁÓW",
    click: "KLIK",
    escape: "ESC",
    hideUi: "UKRYJ UI",
    closeInspector: "Zamknij panel",
    expandInspector: "Rozwiń szczegóły panelu",
    collapseInspector: "Zwiń szczegóły panelu",
    stateVector: "WEKTOR STANU",
    lastSignal: "OSTATNI SYGNAŁ",
    revision: "REWIZJA",
    objects: "OBIEKTY",
    class: "KLASA",
    connectedEntities: "POWIĄZANE ENCJE",
    systemComponents: "KOMPONENTY SYSTEMU",
    recentSignals: "OSTATNIE SYGNAŁY",
    openSystem: "PRZEJDŹ DO SYSTEMU",
    unknown: "NIEZNANE",
    orbitalIdentity: "TOŻSAMOŚĆ ORBITALNA",
    parentSystem: "SYSTEM NADRZĘDNY",
    orbitalClass: "KLASA ORBITALNA",
    languageSelector: "Język",
    switchLanguage: (value) => `Przełącz język na ${value}`,
    semanticMap: "Nawigator konstelacji",
    semanticMapHint: "Dostępna z klawiatury mapa żywej konstelacji",
    accessibleObservatory: "Dostępne obserwatorium",
    accessibleObservatoryOn: "Tryb dostępnego obserwatorium włączony",
    accessibleObservatoryOff: "Tryb dostępnego obserwatorium wyłączony",
    navProduct: "Produkt",
    navHowItWorks: "Jak to działa",
    navSolutions: "Rozwiązania",
    navResources: "Zasoby",
    navAboutUs: "O nas",
    getStarted: "Start",
    heroHeadlineLine1: "Między światami.",
    heroHeadlineLine2Prefix: "Wejdź do",
    heroHeadlineLine2Accent: "Nexusa.",
    heroDescription:
      "Żywy przekaźnik kaim.dev — manifesty, relacje i stan odwzorowane jako jeden nawigowalny kosmos.",
    startMapping: "Wejdź do Nexusa",
    watchVision: "Pokaż rdzeń",
    demoTour: "Trasa zwiadu",
    exitDemoTour: "Zakończ zwiad",
    heroEyebrow: "MIDGARD RELAY / LIVE",
    nowLabel: "TERAZ",
    overviewLabel: "Atlas",
  },
  nodes: {
    kaimDev: {
      label: "KAIM.DEV",
      eyebrow: "TOŻSAMOŚĆ / PORTFOLIO",
      description: "Główna publiczna warstwa tożsamości i portfolio całego ekosystemu.",
    },
    goals: {
      label: "K·100",
      eyebrow: "CELE / PRZYSZŁOŚCI",
      description: "Żywy atlas stu celów, prognoz i stanu rynku predykcyjnego.",
    },
    build: {
      label: "K·BUILD",
      eyebrow: "DOM / MICHAŁOWICE",
      description: "Kompletny system wiedzy, stanu i procesu budowy domu w Michałowicach.",
    },
    photos: {
      label: "ZDJĘCIA",
      eyebrow: "ARCHIWUM / PAMIĘĆ",
      description: "photos.kaim.dev — platforma archiwum fotograficznego hostująca prywatne, nazwane instancje.",
    },
    breakglass: {
      label: "BREAKGLASS",
      eyebrow: "SATYRA / AI",
      description: "Satyryczny interfejs awaryjny dotyczący nadmiernej ekspozycji na AI.",
    },
    home: {
      label: "DOM",
      eyebrow: "AUTOMATYKA / FIZYCZNOŚĆ",
      description: "Przyszły most Home Assistant i telemetria fizycznego stanu domu.",
    },
    okolica: {
      label: "OKOLICA DZIAŁKI",
      eyebrow: "INTELIGENCJA LOKALIZACYJNA",
      description:
        "Inteligencja lokalizacyjna na poziomie działki: planowanie, mobilność, teren i kontekst środowiskowy.",
    },
    michalowice: {
      label: "MICHAŁOWICE",
      eyebrow: "DZIAŁKA / 841 M²",
      description: "Główna fizyczna kotwica: wybrana działka i przyszła lokalizacja domu.",
    },
    houseGoal: {
      label: "CEL: DOM",
      eyebrow: "CEL / MIESZKANIOWY",
      description: "Cel długiego horyzontu opisujący przejście od zakupu działki do ukończonego domu.",
    },
    house: {
      label: "DOM",
      eyebrow: "FIZYCZNY / MIESZKANIOWY",
      description: "Fizyczny dom projektowany i budowany na działce w Michałowicach.",
    },
    marketEngine: {
      label: "SILNIK RYNKU",
      eyebrow: "LMSR / INTEGRALNOŚĆ",
      description: "Sekwencjonowany stan LMSR, ledger i projekcja portfela stojąca za K·100 Futures.",
    },
    portfolioFrontier: {
      label: "PORTFOLIO FRONTIER",
      eyebrow: "WORKER / WDROŻENIE",
      description: "Powierzchnia Cloudflare Worker serwująca publiczne portfolio.",
    },
    photoArchive: {
      label: "KOLEKCJA 01",
      eyebrow: "20 769 OBIEKTÓW",
      description: "Zindeksowana kolekcja źródłowa stojąca za warstwą archiwum fotograficznego.",
    },
    aferyLekarskie: {
      label: "AFERY LEKARSKIE",
      eyebrow: "SATYRA / GENERATOR",
      description: "Lekki, statyczny generator fikcyjnych afer lekarskich działający bez bazy i kont użytkowników.",
    },
  },
  orbitals: {
    goalsDo: {
      label: "KOORDYNATOR INTEGRALNOŚCI",
      eyebrow: "DURABLE OBJECT / SEKWENCER",
      description:
        "Sekwencer stanu zapewniający porządek transakcji, kontrole integralności i deterministyczne projekcje rynku.",
    },
    goalsD1: {
      label: "MARKET D1",
      eyebrow: "STAN / POZYCJE / LEDGER",
      description: "Relacyjna warstwa przechowująca konta, pozycje, ledger i agregaty rynku.",
    },
    goalsFuturesUi: {
      label: "FUTURES UI",
      eyebrow: "WARSTWA RYNKU / INTERAKCJA",
      description: "Interfejs użytkownika dla cen, pozycji, portfeli i guidance.",
    },
    goalsLedger: {
      label: "STRUMIEŃ LEDGERA",
      eyebrow: "APPEND-ONLY / TRANSAKCJE",
      description: "Append-only historia transakcji i strumień zdarzeń do rekonstrukcji stanu rynku.",
    },
    kaimWorker: {
      label: "PORTFOLIO FRONTIER",
      eyebrow: "CLOUDFLARE WORKER / EDGE",
      description: "Główny runtime edge serwujący portfolio i publiczne ścieżki.",
    },
    kaimStudioApi: {
      label: "STUDIO API",
      eyebrow: "TREŚĆ / POWIERZCHNIA STUDIO",
      description: "Wewnętrzna warstwa API wspierająca operacje treściowe i przyszłe capability studia.",
    },
    kaimAccess: {
      label: "ZERO TRUST ACCESS",
      eyebrow: "DOSTĘP / OCHRONA",
      description: "Warstwa dostępu chroniąca prywatne interfejsy i powierzchnie wewnętrzne.",
    },
    kaimDesignSystem: {
      label: "WARSTWA DESIGNU",
      eyebrow: "TYPOGRAFIA / MOTION / TOKENY",
      description: "Wspólny język wizualny spajający layout, motion i typografię całego ekosystemu.",
    },
    kaimNexusConnector: {
      label: "NEXUS CONNECTOR",
      eyebrow: "MCP / API / GRAF",
      description:
        "Maszynowy przekaźnik między światami kaim.dev: manifesty stają się współrzędnymi, a relacje trasami.",
    },
    photosArchiveIndex: {
      label: "INDEKS ARCHIWUM",
      eyebrow: "MATERIALIZOWANY / SEARCH",
      description: "Materializowany indeks i summary zdjęć generowane przy normalnym indeksowaniu archiwum.",
    },
    photosObjectStore: {
      label: "OBJECT STORE",
      eyebrow: "MEDIA / STORAGE",
      description:
        "Warstwa składowania Photos; Nexus pobiera tylko agregaty i nigdy nie wykonuje listowania obiektów na żądanie.",
    },
    photosRozaInstance: {
      label: "INSTANCJA RÓŻA",
      eyebrow: "roza.photos.kaim.dev / PRYWATNA",
      description:
        "Konkretna prywatna instancja Photos reprezentowana wyłącznie przez zredagowany stan, rewizję i metadane indeksu.",
    },
    homeAssistant: {
      label: "HOME ASSISTANT",
      eyebrow: "AUTOMATYKA / CONTROL",
      description: "Przyszła lokalna warstwa sterująca urządzeniami, scenami i stanem domu.",
    },
    homePhysicalHost: {
      label: "FIZYCZNY HOST",
      eyebrow: "NETTOP / LOCAL",
      description: "Lokalny host przeznaczony dla Home Assistant i mostu stanu fizycznego do ekosystemu.",
    },
    homeRemoteAccess: {
      label: "ZDALNY DOSTĘP",
      eyebrow: "smarthome.kaim.dev / EDGE",
      description:
        "Chronione wejście zdalne do warstwy sterowania bez wystawiania surowej telemetrii lokalnej do Nexusa.",
    },
    okolicaCadastrePlanning: {
      label: "KATASTER + PLANOWANIE",
      eyebrow: "ULDK / MPZP",
      description: "Granice parceli i kontekst planistyczny materializowane dla wybranej działki.",
    },
    okolicaTerrainEnvironment: {
      label: "TEREN + ŚRODOWISKO",
      eyebrow: "SPADEK / RYZYKO / KONTEKST",
      description: "Wstępnie policzone podsumowanie terenu i środowiska używane przez analizę działki.",
    },
    okolicaMobility: {
      label: "MOBILNOŚĆ",
      eyebrow: "DROGI / DOSTĘP",
      description: "Wstępnie policzone podsumowanie dostępu i mobilności zamiast wywołań routingu z Nexusa.",
    },
    okolicaEvidenceExport: {
      label: "EKSPORT DOWODÓW",
      eyebrow: "GEOJSON / SNAPSHOT",
      description:
        "Wersjonowany artefakt dowodowy konsumowany przez K·BUILD bez ponownego uruchamiania analizy lokalizacyjnej.",
    },
    breakglassEdgeRuntime: {
      label: "EDGE RUNTIME",
      eyebrow: "CLOUDFLARE / DELIVERY",
      description: "Publiczny runtime edge serwujący scenariusze Breakglass i statyczne metadane systemu.",
    },
    breakglassScenarioEngine: {
      label: "SILNIK SCENARIUSZY",
      eyebrow: "REJESTR / TRYBY",
      description:
        "Rejestr scenariuszy i deterministyczna konfiguracja trybów wystawiana do Nexusa wyłącznie jako summary.",
    },
    buildBrief: {
      label: "BRIEF ARCHITEKTONICZNY",
      eyebrow: "PROGRAM / WYMAGANIA",
      description: "Strukturalny brief architektoniczny opisujący program, intencję przestrzenną i ograniczenia.",
    },
    buildDocuments: {
      label: "ATLAS DOKUMENTÓW",
      eyebrow: "PLIKI / DECYZJE / DOWODY",
      description: "Warstwa wiedzy spinająca dokumenty, decyzje, kamienie milowe i ślady procesu.",
    },
    buildPlotIntel: {
      label: "INTELIGENCJA DZIAŁKI",
      eyebrow: "TEREN / PLANOWANIE / KONTEKST",
      description: "Analiza kontekstu parceli zasilana przez Okolicę Działki i pokrewne źródła planistyczne.",
    },
    buildTimeline: {
      label: "OŚ KAMIENI MILOWYCH",
      eyebrow: "PROCES / ETAPY",
      description: "System kamieni milowych śledzący fazy projektu, zgody i gotowość do budowy.",
    },
  },
  events: {
    "build.brief.updated": (e) => ({
      title: `Zaakceptowano brief architektoniczny v${n(e, "version", 3)}`,
      detail: "Program przeszedł do uporządkowanego stanu pre-design.",
    }),
    "goal.progress.updated": (e) => ({
      title: `Cel #${n(e, "goal", 34)} → ${n(e, "progress", 48)}%`,
      detail: "Zaktualizowano projekcję postępu.",
    }),
    "portfolio.deployed": (e) => ({
      title: "Wdrożono portfolio-frontier",
      detail: `Produkcyjna rewizja edge ${n(e, "revision", "nieznana")}.`,
    }),
    "photos.indexed": (e) => ({
      title: "Przebudowano manifest kolekcji",
      detail: `Zindeksowano ${Number(n(e, "count", 0)).toLocaleString("pl-PL")} obiektów źródłowych.`,
    }),
    "home.simulation": () => ({
      title: "Węzeł DOM czeka na fizyczny host",
      detail: "Telemetria pozostaje symulowana w obecnym prototypie.",
    }),
    "market.integrity": () => ({
      title: "Koordynator integralności rynku działa poprawnie",
      detail: "Dostępna jest sekwencjonowana projekcja stanu.",
    }),
    "build.state.sampled": () => ({
      title: "Zsynchronizowano stan budowy",
      detail: "K·BUILD opublikował nowy materializowany snapshot budowy.",
    }),
    "goals.market.sampled": () => ({
      title: "Uzgodniono snapshot rynku K·100",
      detail: "Mockowa projekcja rynku zgodziła się z bieżącą głowicą ledgera.",
    }),
    "portfolio.edge.sampled": () => ({
      title: "Heartbeat wdrożenia edge",
      detail: "portfolio-frontier odpowiedział w nominalnym oknie.",
    }),
    "photos.manifest.sampled": () => ({
      title: "Heartbeat indeksu archiwum",
      detail: "Manifest kolekcji pozostaje dostępny.",
    }),
    "home.awaiting-host": () => ({
      title: "Węzeł fizyczny nie jest jeszcze przygotowany",
      detail: "To oczekiwane w obecnej fazie mocka.",
    }),
    "location.context.sampled": () => ({
      title: "Odświeżono kontekst parceli",
      detail: "Odświeżono mockową projekcję inteligencji lokalizacyjnej.",
    }),
  },
} satisfies LocaleCatalog;
